






























































































































import Vue from "vue";
import Price from "@/lib/price";
import Date from "@/lib/convertDate";
import Locale from "@/lib/locale";
import { defaultChangePlansData } from "@/components/AboutChangePlansSb/props";
import { Data, Method, Computed, Props } from "./PaymentInformationType";

export default Vue.extend<Data, Method, Computed, Props>({
  props: {
    lang: { default: () => ({}) },
    changePlansData: {
      default: () => defaultChangePlansData
    }
  },
  data() {
    return {
      locale: Locale.getLocale()
    };
  },
  methods: {
    getConvertDate(timestamp: number) {
      return Date.getDate(timestamp, this.locale, "yyyy/M/d");
    },
    replaceDateText(text: string, timestamp: number) {
      return text.replace(":date", this.getConvertDate(timestamp));
    },
    replaceText(text: string, replaceKey: string, replaceText: string) {
      return text.replace(replaceKey, replaceText);
    },
    replacePrice(text: string, replacePrice: number) {
      return text.replace(
        ":price",
        Price.getPrice(this.changePlansData.currencyCode, replacePrice)
      );
    },
    isUpgradeChangeSettlementScheduledAt() {
      return (this.existUpComingTotal() &&
        this.changePlansData.isChangeSettlementScheduledAt &&
        !this.changePlansData.isFreePeriodEnd) as boolean;
    },
    isUpgradeNotChangeSettlementScheduledAt() {
      return (this.existUpComingTotal() &&
        !this.changePlansData.isChangeSettlementScheduledAt &&
        !this.changePlansData.isFreePeriodEnd) as boolean;
    },
    isMonthlyFreeTrial() {
      return (this.changePlansData.isMonthlyFreeTrials &&
        !this.changePlansData.isFreePeriodEnd) as boolean;
    },
    isDowngrade() {
      return (!this.existUpComingTotal() &&
        this.changePlansData.freePeriodAt &&
        !this.changePlansData.isFreePeriodEnd) as boolean;
    },
    isFreePeriodEnd() {
      return (
        this.existUpComingTotal() &&
        (this.changePlansData.isFreePeriodEnd as boolean)
      );
    },
    existUpComingTotal() {
      return "upcomingTotal" in this.changePlansData;
    }
  },
  computed: {
    upcomingPrice(): string {
      if (typeof this.changePlansData.upcomingTotal === "undefined") return "";

      return this.lang.payment_price_info.text_1.replace(
        ":price",
        Price.getPrice(
          this.changePlansData.currencyCode,
          this.changePlansData.upcomingTotal
        )
      );
    },
    nextPaymentPrice(): string {
      let nextPaymentPrice = this.lang.monthly_price;
      if (this.changePlansData.settlementScheduledTerm === "year") {
        nextPaymentPrice = this.lang.yearly_price;
      }

      nextPaymentPrice = nextPaymentPrice.replace(
        ":price",
        Price.getPrice(
          this.changePlansData.currencyCode,
          Number(this.changePlansData.settlementScheduledPrice)
        )
      );

      return nextPaymentPrice;
    },
    nextSettlementScheduledAt(): string {
      if (!this.changePlansData.settlementScheduledAt) return "";

      return this.lang.next_due_date.replace(
        ":date",
        Date.getDate(
          this.changePlansData.settlementScheduledAt,
          this.locale,
          "yyyy/M/d"
        )
      );
    }
  }
});
